
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'
import StoreUtil from '@/stores/StoreUtil'

export default defineComponent({
  name: 'MessageDialog',
  setup() {
    const messageDialogStore = StoreUtil.useStore('MessageDialogStore')
    return {
      messageDialogStore,
      ...useI18n(),
      /**
       * ダイアログのOKボタンがクリックされると呼び出される。
       */
      clickOk() {
        messageDialogStore.close('OK')
      },
      /**
       * ダイアログのキャンセルボタンがクリックされると呼び出される。
       */
      clickCancel() {
        messageDialogStore.close('Cancel')
      },
    }
  },
})
